export interface Dictionary<T = any> {
  [index: string]: T;
}
